import { JobCandidateStatusResponse } from 'common/models/Jobs/Job';
import { useEffect, useMemo, useState } from 'react';
import { GetJobsSettings } from 'services/ConfigurationService';
import { GetWorkflowItemsOrder } from 'services/WorkflowService';

export default function useWorkflowOrder() {
  const [workflowSortType, setWorkflowSortType] = useState<'alphabetical' | 'workflow'>(
    'alphabetical'
  );
  const [workflowOrder, setWorkflowOrder] = useState<JobCandidateStatusResponse[]>([]);

  useEffect(() => {
    const getWorkflowConfig = async () => {
      const jobSettings = await GetJobsSettings();
      if (jobSettings) {
        const orderSetting = jobSettings.find((s) => s.type === 'WorkflowSortOrder');
        if (orderSetting && orderSetting.value === '1') {
          setWorkflowSortType('workflow');
          const order = await GetWorkflowItemsOrder();
          if (order) {
            const sortedOrder = order.sort((a, b) => a.statusOrder - b.statusOrder);
            setWorkflowOrder(sortedOrder);
          }
        }
      }
    };
    getWorkflowConfig();
  }, []);

  const indexes = useMemo(() => {
    let offerIndex: number | undefined = undefined;
    let interviewIndex: number | undefined = undefined;
    let refCheckIndex: number | undefined = undefined;
    let submitIndex: number | undefined = undefined;
    const indexes: Record<number, number | undefined> = {};

    for (let i = 0; i < workflowOrder.length; i++) {
      const w = workflowOrder[i];
      if (offerIndex === undefined && w.name === 'Offered') offerIndex = i;
      else if (submitIndex === undefined && w.name === 'Submitted') submitIndex = i;
      else if (
        interviewIndex === undefined &&
        (w.name === '1st Interview' ||
          w.name === '2nd Interview' ||
          w.name === '3rd Interview' ||
          w.name === '4th Interview' ||
          w.name === 'Internal Interview')
      )
        interviewIndex = i;
      else if (refCheckIndex === undefined && w.name === 'Reference Checked') refCheckIndex = i;
      else {
        indexes[w.id] = i;
      }
    }
    return {
      sortType: workflowSortType,
      offerIndex,
      interviewIndex,
      refCheckIndex,
      submitIndex,
      indexes,
    };
  }, [workflowOrder, workflowSortType]);

  return indexes;
}
